export default __webpack_public_path__ + "static/media/cross.110ff041.png";